import React, { useMemo, useCallback } from "react";
import { Button } from 'semantic-ui-react'
import { Search } from "./Search"
import logo from "../logo_title_light.png";
import logoGreen from "../logo_title_green.png";
import "./buttons.css"

export const Header = ({
	stockLoading, 
	cryptoLoading, 
	forexLoading,
	setAssetType,
	assetType,
	stockTickers,
        cryptoTickers, 
        forexTickers,
        setSelectedTickers,
        selectedTickers,
}) => {
  	const tickers = useMemo(() => {
		if (assetType === "Stock") return stockTickers;
		if (assetType === "Crypto") return cryptoTickers;
		return forexTickers;
	}, [assetType, stockTickers, cryptoTickers, forexTickers]);

	const handleStockClick = useCallback(() => {
		setAssetType("Stock");
	}, [setAssetType]);

	const handleCryptoClick = useCallback(() => {
		setAssetType("Crypto");
	}, [setAssetType]);

	const handleForexClick = useCallback(() => {
		setAssetType("Forex");
	}, [setAssetType]);
	
	return (
		<>
                <div id="search">
                        <Search
				setSelectedTickers={setSelectedTickers}
				selectedTickers={selectedTickers}
				tickers={tickers}
			/>
                </div>
		<div id="header">
		  <div id="logo">
			<img
          			className="logo-img"
          			src={assetType === "Forex" ? logoGreen : logo}
          			alt="catchfire.finance - Financial Data Visualization"
        		/>
		  </div>
		  <div id="search-placeholder">
		  </div>
		  <div id="buttons">
		     <div id="button-container">
			<Button
				className={`margin ${assetType === "Stock" ? "active-button" : ""}`}
		            	circular 
		            	onClick={handleStockClick} 
		            	size='small' 
		            	compact 
				disabled={stockLoading}
		            	loading={stockLoading} 
		            	basic
		            	color={assetType === "Forex" ? "green" : "orange"} 
				active={assetType === "Stock"}>Stock</Button>
			<Button
		                className={`margin ${assetType === "Crypto" ? "active-button" : ""}`}
		            	circular 
		            	onClick={handleCryptoClick} 
		            	size='small' 
		           	compact 
				disabled={cryptoLoading}
		            	loading={cryptoLoading} 
		            	basic
		            	color={assetType === "Forex" ? "green" : "orange"} 
				active={assetType === "Crypto"}>Crypto</Button>
			<Button
		                className={`margin ${assetType === "Forex" ? "active-button" : ""}`}
		            	circular 
		            	onClick={handleForexClick} 
		            	size='small' 
		           	compact 
				disabled={forexLoading}
		            	loading={forexLoading} 
		            	basic
		            	color={assetType === "Forex" ? "green" : "orange"} 
				active={assetType === "Forex"}>Forex</Button>
		  </div>
		 </div>
		</div>
		</>
	);
};
